'use client';
import React, { useCallback, useEffect, useState } from 'react';
import LoaderInfoDoc from '../admission/loading/LoaderInfoDoc';
import HeaderMission from '../admission/layout/HeaderMission';
import Content_Roting from '../admission/layout/Content_Roting';
import { GoAlertFill } from 'react-icons/go';
import { rulesDataModal } from '@/constant';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import {
    setFormModal,
    setSelectedTurn,
} from '@/lib/RTK/features/AdmissionSlice';
import { Button } from '@/components/ui/button';
import { useRouter } from 'next/navigation';
import { formatNameDoctor } from '@/constant/scripts';
import { FaPerson } from 'react-icons/fa6';
import parse, { DOMNode, Element } from 'html-react-parser';
import { GiBackwardTime } from 'react-icons/gi';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { baseStaticURL } from '@/lib/servies/axiosConfig';
import axios from 'axios';
import CollapsibleText from '@/components/layout/collapsible-texts';

interface Props {
    plus_service_turn: string | null;
    isPending: boolean;
    step: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    selectedValue: string;
    enableSubmit: boolean;
    docid: string;
    clinic: string;
    docname: string;
    per_visit: string;
    timeTurnfirst?: {
        first_date: string;
        first_time: string;
    };
    setSubmitEnable: (val: boolean) => void;
    setShowTurnModal: (val: boolean) => void;
    setStep: (val: number) => void;
    handleChange: (val: string) => void;
}

const TurnFirstSteps = ({
    isPending,
    plus_service_turn,
    step,
    data,
    selectedValue,
    enableSubmit,
    docid,
    docname,
    timeTurnfirst,
    clinic,
    per_visit,
    setSubmitEnable,
    setStep,
    setShowTurnModal,
}: Props) => {
    const selectedTurn = useAppSelector((s) => s.admission.currentTurnTimeDate);
    const [acceptModal, setAccentModal] = useState(false);
    const dispatch = useAppDispatch();
    const router = useRouter();

    const { token, register, mobile } = useAppSelector(
        (state) => state.auth_token_slice,
    );

    useEffect(() => {
        if (plus_service_turn) {
            setSubmitEnable(false);
            return;
        }
        if (selectedValue === 'first') {
            setSubmitEnable(true);
        } else {
            process.nextTick(() => {
                window.scrollTo(0, 200);
            });
        }
    }, [selectedValue]);

    const { data: prevReserve } = useQuery({
        queryKey: ['check-reserve', mobile],
        queryFn: async () => {
            try {
                const url = `${baseStaticURL}/checkReserve`;

                const response = await axios.get(url, {
                    headers: {
                        Auth: `Bearer ${token}`,
                    },
                });
                return response.data.result;
            } catch {
                throw new Error('Error fetching data');
            }
        },
    });

    const updateModalPage = useCallback(() => {
        setShowTurnModal(false);
        setStep(1);
        if (!token || token === 'undefined') {
            setTimeout(() => {
                dispatch(setFormModal('formlogin'));
            }, 20);
        } else {
            if (register === '1') {
                dispatch(setFormModal('formturn'));
                dispatch(
                    setSelectedTurn({
                        date:
                            selectedTurn?.date ||
                            timeTurnfirst?.first_date ||
                            '',
                        time:
                            selectedTurn?.time ||
                            timeTurnfirst?.first_time ||
                            '',
                        jalali: selectedTurn?.jalali || '',
                        childId: '0',
                    }),
                );
            } else {
                router.push(
                    `/doctor/${docid}/${formatNameDoctor(
                        docname,
                    )}/${clinic}/turn`,
                );
            }
        }
    }, [token]);

    const queryClient = useQueryClient();
    const prevTurn:
        | {
              time: string;
              doctor_name: string;
              date: string;
              gdate: string;
              office: string;
          }
        | undefined = queryClient.getQueryData([
        'check-reserve',
        mobile,
        token,
    ]);
    return (
        <>
            {!isPending ? (
                <main
                    className={`${
                        step === 2
                            ? 'sm:!px-6 sm:!py-1'
                            : 'sm:!pt-0 md:!pb-0 !pb-[50px]'
                    } custom_scroll_bar overflow-x-hidden py-2 max-h-screen md:!max-h-[85vh] h-max !px-2`}
                >
                    {step == 1 ? (
                        <>
                            {data?.result ? (
                                <aside className="w-full mb-3">
                                    <HeaderMission
                                        plus={data.result.plus}
                                        docInfo={data.result.doctor}
                                        clinic={data.result.clinic}
                                    />
                                    <h2
                                        className={
                                            'text-black font-semibold flex gap-1 items-center pb-2.5 pt-6'
                                        }
                                    >
                                        ملاحظات{' '}
                                        {clinic == 'matab' ? 'مطب' : 'مرکز'}
                                    </h2>
                                    <div className="grid smp:!grid-cols-2 gap-3">
                                        <div className="flex gap-2 items-top bg-secondary-shaded p-2 px-4 sm:!p-4 rounded-2xl">
                                            <FaPerson className="text-secondary-s  min-h-[16px] min-w-[16px] text-base" />
                                            <p className="text-[13px] text-[#222222D6] text-justify">
                                                کاربر گرامی، زمان و ساعت نوبتی
                                                که در سایت ثبت می کنید، فقط
                                                مربوط به حضور شما در مطب می باشد
                                                و زمان ویزیت بعد از حضور شما در
                                                مطب، توسط منشی مشخص می شود
                                            </p>
                                        </div>
                                        {per_visit && (
                                            <div className="flex gap-2 items-top bg-secondary-shaded p-2 px-4  sm:!p-4 rounded-2xl">
                                                <FaPerson className="text-secondary-s text-base min-h-[16px] min-w-[16px]" />

                                                <CollapsibleText
                                                    bg="#FFF4EE"
                                                    text={parse(
                                                        per_visit
                                                            ? per_visit
                                                            : '',
                                                        {
                                                            replace: (
                                                                node: DOMNode,
                                                            ) => {
                                                                if (
                                                                    node instanceof
                                                                    Element
                                                                ) {
                                                                    if (
                                                                        node.attribs &&
                                                                        node
                                                                            .attribs
                                                                            .style
                                                                    ) {
                                                                        delete node
                                                                            .attribs
                                                                            .style;
                                                                    }
                                                                    return node;
                                                                }
                                                                return undefined;
                                                            },
                                                        },
                                                    )}
                                                    className="[&>*]:!pt-0"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </aside>
                            ) : (
                                <LoaderInfoDoc />
                            )}
                            <article>
                                <article className="my-4">
                                    {(selectedValue === 'second' ||
                                        plus_service_turn) && (
                                        <Content_Roting
                                            setSubmitEnable={setSubmitEnable}
                                            timeTurnfirst={timeTurnfirst}
                                            doctor={{
                                                docid,
                                                clinic,
                                            }}
                                            allTurns={
                                                data?.result?.all_am_turns
                                            }
                                            dates={data?.result?.months}
                                            matab_plus_id={
                                                data?.result?.plus?.id
                                            }
                                            setStep={setStep}
                                        />
                                    )}
                                </article>
                            </article>
                        </>
                    ) : step == 2 ? (
                        <>
                            <div className="mb-4 bg-blue-shaded sm:!pt-4 sm:!pb-0 pt-2 rounded-2xl">
                                <div className="relative sm:!px-6 px-2 mb-1 overflow-hidden transition-[max-height] duration-500 ease-in-out max-h-[1000px] pb-3">
                                    <div className="flex gap-1 items-center my-5 font-bold">
                                        <p className="text-[17px] flex items-center gap-2 text-red-600">
                                            <GoAlertFill className="i_f" />
                                            توجه
                                        </p>
                                        <p className="text-[15px] pt-0.5 leading-normal">
                                            کاربر گرامی:
                                        </p>
                                    </div>

                                    <fieldset className="mb-[15px] pb-3 flex items-center gap-5 font-semibold">
                                        <ul className="list-disc mr-4 flex_col gap-3">
                                            {rulesDataModal(
                                                data?.result?.doctor?.name ||
                                                    'نام',
                                                data?.result?.doctor
                                                    ?.per_visit &&
                                                    data?.result?.doctor?.per_visit.trim()
                                                        .length > 0
                                                    ? parse(
                                                          data?.result?.doctor
                                                              ?.per_visit,
                                                      )
                                                    : undefined,
                                                data?.result?.doctor
                                                    ?.coordination || 'دارد',
                                                false,
                                            ).map(
                                                (i) =>
                                                    i && (
                                                        <li
                                                            key={i?.id}
                                                            className={`text-sm ${
                                                                i?.active
                                                                    ? 'text-red-700'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {i?.label}
                                                        </li>
                                                    ),
                                            )}
                                        </ul>
                                    </fieldset>
                                </div>
                            </div>

                            <div className="flex justify-between gap-y-2 smp:!flex-row flex-col-reverse items-start">
                                <fieldset
                                    className="flex gap-2 smp:!pr-5 pb-5 w-fit items-center select-none font-bold"
                                    onClick={() => setAccentModal(!acceptModal)}
                                >
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 accent-blue"
                                        checked={acceptModal}
                                        onChange={() => {}}
                                    />
                                    تایید می کنم
                                </fieldset>

                                {selectedTurn ? (
                                    <div className="flex justify-between smp:!w-max w-full items-center gap-1.5">
                                        <p className="font-regular whitespace-nowrap text-[#222222]">
                                            زمان نوبت:
                                        </p>
                                        <div className="flex gap-2 smp:!w-max w-full items-center flex-wrap font-medium text-[#222222] text-sm">
                                            <p>
                                                تاریخ :{' '}
                                                {selectedTurn?.jalali ||
                                                    'زمانی ثبت نشده است'}
                                            </p>
                                            <p>ساعت : {selectedTurn?.time}</p>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </>
                    ) : prevTurn ? (
                        <div className="text-center pb-8">
                            <div className="bg-blue-shaded p-2 w-max mx-auto rounded-2xl flex justify-center items-center">
                                <GiBackwardTime className="text-blue text-2xl" />
                            </div>
                            <p className="font-semibold pt-4">
                                یک نوبت برای دکتر {prevTurn?.doctor_name} در
                                تاریخ {prevTurn?.date} ، <br /> ساعت{' '}
                                {prevTurn?.time + ' '} از قبل برای شما رزرو شده
                                است.
                            </p>
                            <p className="pt-1">
                                آیا مایل به ثبت نوبت جدید هستید ؟
                            </p>
                        </div>
                    ) : null}
                    <div className="flex gap-4 justify-end items-center ">
                        {step === 3 && (
                            <Button
                                variant={'primaryShaded'}
                                className="!py-2 !px-6 bg-blue-shaded hover:!bg-blue-shaded text-blue !rounded-md w-full"
                                onClick={() => {
                                    setShowTurnModal(false);
                                    dispatch(
                                        setSelectedTurn({
                                            date: prevTurn?.gdate || '',
                                            time: prevTurn?.time || '',
                                            jalali: prevTurn?.date || '',
                                            childId: '',
                                        }),
                                    );
                                    router.push(
                                        `/doctor/${docid}/${formatNameDoctor(
                                            docname,
                                        )}/${
                                            prevTurn?.office
                                        }/continue/checkout`,
                                    );
                                }}
                            >
                                تکمیل نوبت قبل
                            </Button>
                        )}
                        {step === 2 && (
                            <Button
                                className="!py-2 !px-6 bg-blue-shaded hover:!bg-blue-shaded text-blue !rounded-md w-full"
                                onClick={() => setStep(1)}
                            >
                                برگشت
                            </Button>
                        )}

                        {/* {step === 1 && (
                            <Button
                                variant={'primaryShaded'}
                                className="!py-2 !px-6 bg-blue-shaded hover:!bg-blue-shaded text-blue !rounded-md w-full"
                                onClick={() => setShowTurnModal(false)}
                            >
                                انصراف
                            </Button>
                        )} */}
                        {step !== 1 && (
                            <Button
                                disabled={
                                    step == 1 ? !enableSubmit : !acceptModal
                                }
                                className="!py-2 !px-6 !rounded-md w-full bg-blue !text-white"
                                onClick={() =>
                                    step == 1
                                        ? setStep(2)
                                        : step == 2
                                        ? prevReserve?.time_left
                                            ? setStep(3)
                                            : updateModalPage()
                                        : updateModalPage()
                                }
                            >
                                {step === 2
                                    ? 'درخواست نوبت'
                                    : step === 1
                                    ? 'ادامه'
                                    : 'ثبت نوبت جدید'}
                            </Button>
                        )}
                    </div>
                </main>
            ) : (
                <p className="pt-5 text-center">لطفا کمی صبر کنید ...</p>
            )}
        </>
    );
};

export default TurnFirstSteps;
